import type { MenuItem } from './types';

export const menuItems: MenuItem[] = [
  {
    id: 'about',
    path: '/',
    hash: '#sobre-mim',
    icon: 'fas fa-skull-crossbones',
    i18n: { 'pt-BR': { label: 'Sobre mim' }, en: { label: 'About me' } },
  },
  {
    id: 'skills',
    path: '/',
    hash: '#conhecimentos',
    icon: 'fas fa-code',
    i18n: { 'pt-BR': { label: 'Conhecimentos' }, en: { label: 'Skills' } },
  },
  {
    id: 'portfolio',
    path: '/',
    hash: '#portfolio',
    icon: 'fas fa-photo-video',
    i18n: { 'pt-BR': { label: 'Portfólio' }, en: { label: 'Portfolio' } },
  },
];
